<template>
  <!-- Rows still loading: a title and a meta line each, hairlines between,
       like .kb-rows. `boxed` draws them in a pane with a title. -->
  <div
    :class="boxed ? 'kb-skel-pane' : ''"
    role="status"
    :aria-label="label"
    aria-busy="true"
  >
    <span
      v-if="boxed"
      class="kb-bone kb-skel-pane-title"
    />
    <ul class="kb-skel-rows">
      <li
        v-for="i in rows"
        :key="i"
      >
        <span class="grid gap-2 flex-1 min-w-0">
          <span
            class="kb-bone"
            :style="{ width: WIDTHS[(i - 1) % WIDTHS.length] }"
          />
          <span
            v-if="meta"
            class="kb-bone kb-bone-sm"
            :style="{ width: META_WIDTHS[(i - 1) % META_WIDTHS.length] }"
          />
        </span>
        <span
          v-if="aside"
          class="kb-bone kb-bone-aside"
        />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  rows?: number
  /** A second, shorter line under each title */
  meta?: boolean
  /** Something on the right of each row (a switch, an amount) */
  aside?: boolean
  boxed?: boolean
  label?: string
}>(), { rows: 4, meta: true, aside: false, boxed: false, label: 'Loading' })

// Uneven lengths read as text; equal ones read as a chart
const WIDTHS = ['46%', '62%', '38%', '55%', '42%']
const META_WIDTHS = ['28%', '22%', '34%', '25%']
</script>
